import React from 'react'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import LinearProgress from '@material-ui/core/LinearProgress'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import styles from '../styles'

const ChatFileUploadView = ({
  toggleIsActive,
  isActive,
  isLoading,
  children,
  classes,
}) => {
  return (
    <div className={classes.wrapper}>
      <div
        className={classes.toggleWrapper}
        onClick={toggleIsActive}
        cypress_id={'chatFileUploadViewIcon'}
      >
        <AttachFileIcon />
      </div>
      <div
        className={classnames(classes.itemsWrapper, 'makeStyles-itemsWrap', {
          'active': isActive,
          'loading': isLoading,
        })}
      >
        {isLoading ? (
          <LinearProgress className={classes.linearProgress} />
        ) : (
          children
        )}
      </div>
      <div />
    </div>
  )
}

export default injectStyles(styles)(ChatFileUploadView)
